import { render, staticRenderFns } from "./socketRealTimeComponent.vue?vue&type=template&id=de5cb8f0&class=full-height&"
import script from "./socketRealTimeComponent.vue?vue&type=script&lang=js&"
export * from "./socketRealTimeComponent.vue?vue&type=script&lang=js&"
import style0 from "./socketRealTimeComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5cb8f0')) {
      api.createRecord('de5cb8f0', component.options)
    } else {
      api.reload('de5cb8f0', component.options)
    }
    module.hot.accept("./socketRealTimeComponent.vue?vue&type=template&id=de5cb8f0&class=full-height&", function () {
      api.rerender('de5cb8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/socketInfo/components/socketRealTimeComponent.vue"
export default component.exports